export function backendErrorDescription(
    error: unknown,
    fallback = "De e-mail kon niet worden verstuurd. Probeer het later opnieuw."
): string {
    if (error instanceof Error && error.name === 'Non200ResponseError'
        && typeof (error as Error & { detail?: unknown }).detail === 'string') {
        return (error as Error & { detail: string }).detail;
    }
    return fallback;
}
